import React, { useEffect, useRef, useState } from "react";

const Home3 = () => {
  const sectionRef = useRef(null);
  const [animateCards, setAnimateCards] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimateCards(true);
        }
      },
      { threshold: 0.4 } // Startet Fade-in wenn 40% der Section sichtbar
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="home3-section" ref={sectionRef} id="home3">
      <div className="home3-container">
        <h2 className="home3-title">
          Warum Qlance der beste Weg zu <span className="highlight3">erfolgreichen</span> Projekten ist
        </h2>
        <div className="home3-underline" />
        <p className="home3-subtitle">
          Unser Versprechen an Unternehmen & Talente: <br />Effizienz, Qualität und Wirkung.
        </p>
        <div className="home3-grid">
          {[
            {
              icon: "/assets/speed.svg",
              title: "Schnell & flexibel",
              text: "Projekte starten innerhalb von 72h – ohne lange Einstellungsprozesse.",
            },
            {
              icon: "/assets/think.svg",
              title: "Top-Talente",
              text: "Top Talente der führenden Businessschools und Senior Experts für ihren Erfolg.",
            },
            {
              icon: "/assets/match.svg",
              title: "Passendes Matching",
              text: "Qlance verbindet Sie effizient & unkompliziert mit passenden Talenten.",
            },
            {
              icon: "/assets/handshake.svg",
              title: "Effiziente Zusammenarbeit",
              text: "Klare Projektziele, persönliche Betreuung & effizientes Management.",
            },
          ].map((card, index) => (
            <div
              key={index}
              className={`home3-card ${animateCards ? "fade-in-card" : ""}`}
style={
  animateCards
    ? {
        transitionDelay: `${index * 0}s, ${index * 0.1}s, 0s`
      }
    : {}
}


            >
              <img src={card.icon} alt={card.title} className="home3-icon" />
              <h3 className="home3-card-title">{card.title}</h3>
              <p className="home3-card-text">{card.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Home3;
